import { TextField } from "@mui/material";
import React from "react";
import CoreTypographyCaption from "../dataDisplay/CoreTypographyCaption";

export default function CoreTextField(props) {
  const { formikProps, ...restProps } = props;
  const { id } = restProps;

  return (
    <>
      <TextField {...restProps} />
      <CoreTypographyCaption color="error">
        {formikProps?.touched[id] && formikProps?.errors[id]}
      </CoreTypographyCaption>
    </>
  );
}
